/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';

const svgStyles = css({
	fill: token('elevation.surface'),
	overflow: 'hidden',
	pointerEvents: 'none',
});

type SharpCornerProps = {
	color?: string;
	label?: string;
};

export const SharpCornerIcon = ({ color, label }: SharpCornerProps): JSX.Element => {
	return (
		<svg
			viewBox="0 0 24 24"
			height="16px"
			width="16px"
			style={{
				color: color ?? token('color.text'),
			}}
			css={svgStyles}
			aria-label={label || undefined}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.75 2H9V4.25H3.75V9.5H1.5V4.25 2H3.75ZM1.5 15.5V20.75 23H3.75 9V20.75H3.75V15.5H1.5ZM20.25 15.5V20.75H15V23H20.25 22.5V20.75 15.5H20.25ZM22.5 9.5V4.25 2H20.25 15V4.25H20.25V9.5H22.5Z"
			/>
		</svg>
	);
};
